import { csx } from '@vtex/admin-ui'

export const content = csx({
  padding: '1.5rem',
})

export const closeIcon = csx({ marginLeft: 'auto' })
